import { FaGlobe, FaFileAlt } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import "../../AuditComplet/ContexteFiscal/ContexteFiscal.css";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import TextField from "components/ui/controls/text-field/text-field";
import Modal from "components/ui/modal/modal";
import DropDown from "components/ui/controls/drop-down/drop-down";

const CorrrectionPERAnnee = (props) => {
  const { Year, TabCorrectionPER, ClientConjoint } = props;

  return (
    <>
      <Modal
        width="860px"
        height="72%"
        title=" Correction du disponible PER 163 quatervicies"
        icon={<FaGlobe />}
        visible={props.visible}
        onClose={() => {
          props?.onClose?.();
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <Column fill>
                  <CardBox>
                    <div className="revenuspro-container" style={{ marginBottom: "20px" }}>
                      {/* Titre au-dessus du tableau */}
                      <div className="dossier-header" style={{ marginBottom: "15px", paddingTop: "0px" }}>
                        <div className="dossier-header-icon">
                          <FaFileAlt />
                        </div>
                        <h1 className="dossier-header-title">Correction du disponible PER pour {Year} - {ClientConjoint ? "Conjoint" : "Client"}</h1>
                      </div>
                      
                      {/* Header des colonnes */}
                      <div className="header-card">
                        <div className="category-column" style={{ textAlign: "left", flex: 2 }}>Paramètres</div>
                        <div className="value-column" style={{ textAlign: "center" }}>Valeurs</div>
                      </div>

                      {/* Conteneur des cartes de contenu */}
                      <div className="card-list-container">
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">💰</div>
                            Rémunération imposable {Year - 1}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={TabCorrectionPER[Year]?.["DeclaPERRemunerationImposable" + ClientConjoint]}
                              onChange={(e) => {
                                props.ChangeValue(Year, "DeclaPERRemunerationImposable" + ClientConjoint, e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">👔</div>
                            Régime fiscal
                          </div>
                          <div className="value-column">
                            <DropDown
                              value={TabCorrectionPER[Year]?.['DeclaPERRegimeFiscal'+ ClientConjoint]}
                              onChange={(e) => {
                                props.ChangeValue(Year, "DeclaPERRegimeFiscal"+ ClientConjoint, e.target.value);
                              }}
                              options={[
                                { value: "tns", label: "Revenus des gérants (art 62 du CGI)" },
                                { value: "bic", label: "BIC/BNC" },
                                { value: "salaire", label: "Traitement et salaires" },
                              ]}
                            />
                          </div>
                        </div>
                        
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">🤝</div>
                           Abondement PERCO net de PS {Year - 1}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={TabCorrectionPER[Year]?.["DeclaPERAbondementPERCO"+ ClientConjoint]}
                              onChange={(e) => {
                                props.ChangeValue(Year, "DeclaPERAbondementPERCO"+ ClientConjoint, e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">🏦</div>
                            Cotisations retraite Madelin {Year - 1}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={TabCorrectionPER[Year]?.["DeclaPERRetraiteMadelin"+ ClientConjoint]}
                              onChange={(e) => {
                                props.ChangeValue(Year, "DeclaPERRetraiteMadelin"+ ClientConjoint, e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">🛡️</div>
                            Cotisations prévoyance et santé Madelin {Year - 1}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={TabCorrectionPER[Year]?.["DeclaPERPrevoyanceMadelin"+ ClientConjoint]}
                              onChange={(e) => {
                                props.ChangeValue(Year, "DeclaPERPrevoyanceMadelin"+ ClientConjoint, e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">🧮</div>
                            Cotisations retraite 83 {Year - 1}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={TabCorrectionPER[Year]?.["DeclaPERRetraite83"+ ClientConjoint]}
                              onChange={(e) => {
                                props.ChangeValue(Year, "DeclaPERRetraite83"+ ClientConjoint, e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">🏛️</div>
                            Cotisations PER 163 quatervicies {Year}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={TabCorrectionPER[Year]?.["DeclaPERRetraite163"+ ClientConjoint]}
                              onChange={(e) => {
                                props.ChangeValue(Year, "DeclaPERRetraite163"+ ClientConjoint, e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: (evt) => {
                props?.onClose?.();
                props?.CalculCorrectionPER(Year,ClientConjoint);
              },
            },
          }}
        />
      </Modal>
    </>
  );
};

export default CorrrectionPERAnnee;
